<span *ngIf="loader" #loader class="loaderAnim"></span>